import { TriangleAlert } from "lucide-react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";

export function RouteErrorPage() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : "An unexpected error interrupted this view.";
  return (
    <main className="centered-page">
      <section className="message-card">
        <span className="message-card__icon"><TriangleAlert size={32} /></span>
        <p className="eyebrow">View unavailable</p>
        <h1>Something went wrong.</h1>
        <p>{message}</p>
        <Link className="button button--primary" to="/admin/dashboard">Return to dashboard</Link>
      </section>
    </main>
  );
}
